import HeaderPanel from "components/HeaderPanel";
import NavigationHeader from "components/NavigationHeader";
import { DogProvider } from "hooks/HeaderContext";
import React, { useEffect, useRef, useState } from "react";
import { FC } from "react";
import GoToTopButton from "components/GoToTopButton";
import Scrollbar from "components/scrollbar/Scrollbar";
import AppRouter from "AppRouter";

const Home: FC = () => {

    const scrollbarRef = useRef<Scrollbar>(null);
    const gotToTopBtnRef = useRef<HTMLButtonElement>();

    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 992);

    useEffect(() => {
        function dogListScroll() { // attach auto-scroll behavior to the "go to top" button
            if (gotToTopBtnRef.current) {
                window.scrollY > 100 ? gotToTopBtnRef.current.classList.add('active') : gotToTopBtnRef.current.classList.remove('active');
            }
        }

        function handleResize() { // attach window-resize to check if device is mobile sized
            setIsMobile(window.innerWidth < 992);
        }

        window.addEventListener('scroll', dogListScroll);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', dogListScroll);
        }


    }, [])

    function scrollPaneScroll() {
        if (gotToTopBtnRef.current) {
            scrollbarRef.current.scrollValues.scrollTop > 100
                ? gotToTopBtnRef.current.classList.add('active')
                : gotToTopBtnRef.current.classList.remove('active');
        }
    }




    return (
        <div className="vw-100 vh-100" >
            <NavigationHeader />
            <DogProvider>
                <HeaderPanel />
                {!isMobile &&
                    <Scrollbar
                        scrollX={false}
                        style={{ flexGrow: 1 }}
                        className="main-panel"
                        ref={scrollbarRef}
                        onScroll={scrollPaneScroll}
                    >
                        <main role="main">
                            <AppRouter />
                        </main>
                    </Scrollbar>
                }
                {isMobile && <AppRouter />}
                <GoToTopButton innerRef={gotToTopBtnRef} scrollbarRef={scrollbarRef} />
            </DogProvider>
        </div>
    )
};
export default Home;
